module.exports = __webpack_public_path__ + "img/user-profile.f338ebed.png";